var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "v-application vuetify-wrapper",
      attrs: { "data-test": "steffi-team-users" },
    },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "4" } },
            [
              _c(
                "v-card",
                { attrs: { outlined: "" } },
                [
                  _c("v-card-title", [_vm._v("Steffi-Team Zugang anlegen")]),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Vorname",
                          outlined: "",
                          dense: "",
                          "data-test": "steffi-team-firstname",
                        },
                        model: {
                          value: _vm.form.firstname,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "firstname", $$v)
                          },
                          expression: "form.firstname",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: {
                          label: "Nachname",
                          outlined: "",
                          dense: "",
                          "data-test": "steffi-team-lastname",
                        },
                        model: {
                          value: _vm.form.lastname,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "lastname", $$v)
                          },
                          expression: "form.lastname",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: {
                          label: "E-Mail",
                          type: "email",
                          outlined: "",
                          dense: "",
                          "data-test": "steffi-team-email",
                        },
                        model: {
                          value: _vm.form.email,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "email", $$v)
                          },
                          expression: "form.email",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            disabled: !_vm.canCreate,
                            loading: _vm.isCreating,
                            "data-test": "steffi-team-create",
                          },
                          on: { click: _vm.createAccount },
                        },
                        [
                          _vm._v(
                            "\n                        Zugang anlegen\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "8" } },
            [
              _c(
                "v-card",
                { attrs: { outlined: "" } },
                [
                  _c(
                    "v-card-title",
                    [
                      _vm._v(
                        "\n                    Steffi-Team\n                    "
                      ),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", loading: _vm.isLoading },
                          on: { click: _vm.fetchAccounts },
                        },
                        [_c("v-icon", [_vm._v("mdi-refresh")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-data-table", {
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.accounts,
                      loading: _vm.isLoading,
                      "item-key": "id",
                      "no-data-text": "Keine Steffi-Team Zugänge",
                      "footer-props": {
                        "items-per-page-text": "Zeilen pro Seite",
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.active",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "v-chip",
                              {
                                attrs: {
                                  small: "",
                                  color: item.active ? "success" : "grey",
                                  "text-color": "white",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      item.active ? "Aktiv" : "Deaktiviert"
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.created",
                        fn: function ({ item }) {
                          return [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  item.created
                                    ? _vm.$formatDate(
                                        item.created,
                                        "DD.MM.YYYY HH:mm"
                                      )
                                    : "-"
                                ) +
                                "\n                    "
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.actions",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  small: "",
                                  text: "",
                                  color: "primary",
                                  disabled: !item.active,
                                  loading: _vm.busyId === `mail-${item.id}`,
                                  "data-test": "steffi-team-resend",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.resendPasswordSetup(item)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            Einrichtungslink senden\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  small: "",
                                  text: "",
                                  color: item.active ? "error" : "success",
                                  loading: _vm.busyId === `active-${item.id}`,
                                  "data-test": "steffi-team-toggle-active",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.setActive(item, !item.active)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      item.active
                                        ? "Deaktivieren"
                                        : "Reaktivieren"
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }